/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingtypereel2Inputs */

const en_crosspostingtypereel2 = /** @type {(inputs: Crosspostingtypereel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reel`)
};

const de_crosspostingtypereel2 = /** @type {(inputs: Crosspostingtypereel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reel`)
};

/**
* | output |
* | --- |
* | "Reel" |
*
* @param {Crosspostingtypereel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingtypereel2 = /** @type {((inputs?: Crosspostingtypereel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingtypereel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingtypereel2(inputs)
	return de_crosspostingtypereel2(inputs)
});
export { crosspostingtypereel2 as "crosspostingTypeReel" }